<script setup lang="ts">
// COMPOSABLES
const { tt } = useTypedI18n();
</script>

<template>
    <footer class="inset-x-0 flex w-full bg-white ring-1 ring-neutral-300">
        <BaseWidthContainer
            class="flex h-(--header-height) flex-col justify-center gap-3 text-xs font-medium md:flex-row-reverse md:items-center md:justify-end"
        >
            <p class="flex flex-row flex-wrap gap-x-3">
                <NuxtLinkLocale to="terms-and-conditions" class="underline hover:no-underline">
                    {{ tt('termsConditions.link') }}
                </NuxtLinkLocale>
                <NuxtLinkLocale to="privacy-policy" class="underline hover:no-underline">{{ tt('privacy.link') }}</NuxtLinkLocale>
                <NuxtLinkLocale to="cookie-policy" class="underline hover:no-underline">
                    {{ tt('footer.cookiePolicy.base') }}
                </NuxtLinkLocale>
            </p>
            <p><FleequidCopyright /></p>
        </BaseWidthContainer>
    </footer>
</template>
